export function randomString(l = 32) {
    const cs = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    return [...new Array(l)].map(() => cs[Math.floor((Math.random() * cs.length))]).join('');
}
